import Vuex from 'vuex';
import Vue from "vue";
import router,{resetRouter} from "@/router";
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

function newRouter(menuList) {
    let routes = router.options.routes;
    routes.forEach(routeItem=>{
        if(routeItem.path==='/index'){
            menuList.forEach(menu=>{
               let newMenu =  {
                        path: '/' + menu.menuclick,
                        name: menu.menuname,
                        meta: {
                            title:  menu.menuname
                        },
                        component: () => import('../pages/' +  menu.menucomponent),
                    };
               routeItem.children.push(newMenu);
            })
        }
    });
    resetRouter();
    router.addRoutes(routes);
}

export default new Vuex.Store({
    state: {
        menu: []
    },
    mutations: {
        setMenu(state, menuList) {
            state.menu = menuList;
            newRouter(menuList);
        },
		setRounter(state, menuList) {
		    newRouter(menuList);
		}
    },
    getters: {
        getMenu(state) {
            return state.menu;
        }
    },
	plugins:[createPersistedState()]
})